// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";

var Styles = {};

function Auth(props) {
  return Belt_Option.mapWithDefault(props.user, props.signedOut, props.signedIn);
}

var ProfileMenuPopover;

var SignedIn;

var SignedOut;

var SignedInMenuItem;

var BusinessSignedOut;

var make = Auth;

export {
  Styles ,
  ProfileMenuPopover ,
  SignedIn ,
  SignedOut ,
  SignedInMenuItem ,
  BusinessSignedOut ,
  make ,
}
/* No side effect */
